import { createAsyncActions } from "~/utils/store";

export var LOAD_BANCOS = createAsyncActions("LOAD_BANCOS");
export var CREATE_BANCO = createAsyncActions("CREATE_BANCO");
export var UPDATE_BANCO = createAsyncActions("UPDATE_BANCO");
export var DELETE_BANCO = createAsyncActions("DELETE_BANCO");

export var loadBancos = function() {
    return {
        type: LOAD_BANCOS.INIT,
        payload: {
            request: {
                method: "GET",
                url: "/bank-accounts",
            },
        },
    };
};

export var createBanco = function(data) {
    return {
        type: CREATE_BANCO.INIT,
        payload: {
            request: {
                method: "POST",
                url: "/bank-accounts",
                data: data,
            },
        },
    };
};

export var updateBanco = function(id, data) {
    return {
        type: UPDATE_BANCO.INIT,
        payload: {
            request: {
                method: "PUT",
                url: "/bank-accounts/" + id,
                data: data,
            },
        },
        id: id,
    };
};

export var deleteBanco = function(id) {
    return {
        type: DELETE_BANCO.INIT,
        payload: {
            request: {
                method: "DELETE",
                url: "/bank-accounts/" + id,
            },
        },
        id: id,
    };
};
